import { toEbookPublishKey } from "@ebook/contracts";

export function toProjectSlug(value: string): string {
  return toEbookPublishKey(value);
}
